const _asEndpoint = (url: string): types.endpoints.IEndpointConfig => {
	return {
		url,
	};
};

export const getImageByPartialPath = (partialPath: string) => {
	return _asEndpoint(partialPath.replace('/wcm/', '').replace('myconnect', 'connect'));
};
